module.exports = __webpack_public_path__ + "assets/2c3f2a5f4e7215d1e4b3fffdbdda9371.svg";